import { render } from "./LnDCarousel.vue?vue&type=template&id=893960d0"
import script from "./LnDCarousel.vue?vue&type=script&lang=js"
export * from "./LnDCarousel.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__